/**
 * Utility functions for the application.
 */

import { clsx, type ClassValue } from 'clsx'
import { twMerge } from 'tailwind-merge'

/**
 * Combines class names using clsx and tailwind-merge.
 *
 * This utility merges Tailwind CSS classes intelligently, ensuring that
 * conflicting classes are properly resolved (e.g., "p-4" overrides "p-2").
 *
 * @param inputs - Class values to merge (strings, objects, arrays)
 * @returns Merged class string
 *
 * @example
 * cn('p-4', 'text-red-500') // => 'p-4 text-red-500'
 * cn('p-4', 'p-2') // => 'p-2' (later value wins)
 * cn('p-4', { 'text-blue-500': true, 'bg-red-500': false }) // => 'p-4 text-blue-500'
 */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs))
}
